<template>
    <CustomTable class="shadow-md">
        <template v-slot:header>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Email</th>
            <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">User Since</th>
        </template>
        <template v-slot:body>
            <tr class="hover:bg-grey-lighter" v-for="member in members" v-if="!polling">
                <td class="py-4 px-6 border-b border-grey-light">{{ member.name }}</td>
                <td class="py-4 px-6 border-b border-grey-light">{{ member.email.toLowerCase() }}</td>
                <td class="py-4 px-6 border-b border-grey-light">{{ member.created_at | displayDate }}</td>
            </tr>
            <tr class="bg-grey-lighter text-center" v-if="polling">
                <td class="py-5" colspan="3">
                    <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                </td>
            </tr>
        </template>
    </CustomTable>
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'MediaNetworkMembers',
		data () {
			return {
                members: {},
                polling: true,
			}
        },
        mounted() {
            this.getMembers();
        },
        components: {
            CustomTable
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getMembers() {
                this.$http.get(Config.apiPath + "/api/v2/media/members", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'members', response.data)
                    this.$set(this, 'polling', false)
                });
            }
        },
        filters: {
            displayDate: function(data) {
                return moment.utc(data).local().format('MM/DD/YY');
            }
        }
	}
</script>

<style scoped>
    
</style>
